import { Navigate, Outlet } from 'react-router-dom';
import { useUsersStore } from '@/stores/users';
import { useOnboarding } from '@/hooks/useOnboarding';

export const ProfileCheckLayout = () => {
  const userData = useUsersStore((state) => state.userData);

  const redirect = useOnboarding();

  if (!userData) return null;

  if (redirect) {
    return <Navigate to={redirect} replace />;
  }

  return <Outlet />;
};
